<i18n>
{
"en": {
  "INCIDENTS": "Incidents",
  "OPEN": "Open",
  "RESOLVED": "Resolved",
  "INCIDENTTYPE": "Incident Type",
  "VIEWINCIDENTDETAILS": "View Incident Details",
  "CHOOSEFILTERBY": "Choose Filter By",
  "FILTERBYSUPERVISOR": "Filter by supervisor",
  "FILTERBYBUS": "Filter by bus",
  "FILTERBYTYPE": "Filter by type",
  "FILTERBYSTATUS": "Filter by status",
  "REPORTED": "Reported",
  "LOADING": "Loading...",
  "BUSSUPERVISOR": "Bus Supervisor",
  "BUS": "Bus",
  "STUDENTS": "Students",
  "STATUS": "Status",
  "TYPE": "Type",
  "DETAILS": "Details",
  "STICK": "Stick",
  "UNSTICK": "Unstick",
  "SUPERVISOR": "Supervisor",
  "CHILDBEHAVIOUR": "Child Behaviour",
  "MEDICAL": "Medical",
  "DRIVERISSUE": "Driver Issue",
  "BUSPROBLEM": "Bus Problem",
  "ACCIDENT": "Accident",
  "TRAFFIC": "Traffic",
  "CALLPOLICE": "Call Police",
  "CALLSCHOOL": "Call School",
  "OTHER": "Other"
},
"ar": {
  "INCIDENTS": "احداث",
  "OPEN": "مفتوحة",
  "RESOLVED": "حل",
  "INCIDENTTYPE": "نوع الحادث",
  "VIEWINCIDENTDETAILS": "عرض تفاصيل الحادث",
  "CHOOSEFILTERBY": "اختر الفلتر المطلوب",
  "FILTERBYSUPERVISOR": "تصفية حسب المشرفة",
  "FILTERBYBUS": "تصفية حسب الحافلة",
  "FILTERBYTYPE": "تصفية حسب النوع",
  "FILTERBYSTATUS": "تصفية حسب الحالة",
  "REPORTED": " المبلغ عنها",
"LOADING": "جار التحميل...",
  "BUSSUPERVISOR": "مشرفة الحافلة",
  "BUS": "حافلة",
  "STUDENTS": "الطلاب",
  "STATUS": "الحالة",
  "TYPE": "نوع",
  "DETAILS": "تفاصيل",
  "STICK": "لصق",
  "UNSTICK": "فك",
  "SUPERVISOR": "مشرفة",
  "CHILDBEHAVIOUR": "سلوك الطفل",
  "MEDICAL": " طبي",
  "DRIVERISSUE": "مشكلة السائق",
  "BUSPROBLEM": "مشكلة الحافلة",
  "ACCIDENT": "حادث",
  "TRAFFIC": "حركة المرور",
  "CALLPOLICE": "اتصل بالشرطة",
  "CALLSCHOOL": "اتصل بالمدرسة",
  "OTHER": "آخر"  
}
}
</i18n>
<template>
  <div id="incident">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{$t('INCIDENTS')}}</span>
      </div>
      <div class="filters" ref="filter">
   
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select  @change="changedFilter"  v-model="filter" :placeholder="$t('CHOOSEFILTERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" 
                v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>        
           </el-col>
         <el-col :span="4"  v-if="active_filter=='monitor'">
             <el-select v-model="BusMonitorID" :placeholder="$t('FILTERBYSUPERVISOR')" filterable clearable  @change="getIncidents(true)">
              <el-option
                :key="index" 
                v-for="(item, index) in monitors"
                :label="_FullName({NameEN: item.FullName_EN, NameAR: item.FullName_AR})"
                :value="item.BusMonitorID">
              </el-option>
            </el-select>        
           </el-col>

         <el-col :span="4"  v-if="active_filter=='bus'">
             <el-select v-model="BusID" :placeholder="$t('FILTERBYBUS')" filterable clearable  @change="getIncidents(true)">
              <el-option
                :key="index" 
                v-for="(item, index) in buses"
                :label="item.Label"
                :value="item.BusID">
              </el-option>
            </el-select>     
           </el-col>

         <el-col :span="4"  v-if="active_filter=='type'">
             <el-select v-model="TypeIncidentID" :placeholder="$t('FILTERBYTYPE')" filterable clearable  @change="getIncidents(true)">
              <el-option
                :key="key"
                v-for="(item, key) in incidentTypes"
                :label="item"
                :value="key">
              </el-option>
            </el-select>       
           </el-col>
          <el-col :span="4"  v-if="active_filter=='status'">
             <el-select v-model="Status" :placeholder="$t('FILTERBYSTATUS')" clearable @change="getIncidents(true)">
              <el-option :label="$t('OPEN')" value="Open">
                <el-tag
                 type="danger"
                close-transition>{{$t('OPEN')}}</el-tag>
              </el-option>
               <el-option :label="$t('REPORTED')" value="Reported">
                <el-tag
                 type="warning"
                close-transition>{{$t('REPORTED')}}</el-tag>
              </el-option>
               <el-option :label="$t('RESOLVED')" value="Resolved">
                <el-tag
                 type="success"
                close-transition>{{$t('RESOLVED')}}</el-tag>
              </el-option>              
            </el-select>      
           </el-col>


          </el-row>
      </div>
      <el-table
       v-loading="new_page || loading"    
        :element-loading-text="$t('LOADING')"
        :data="incidents[currentPage - 1]"
        :height="tableHeight"
        stripe
        style="width: 100%;">
        <el-table-column
          :label="$t('BUSSUPERVISOR')"        
          width="200"
        >
           <template slot-scope="scope">
             {{_FullName({NameEN: scope.row.monitor.FullName_EN, NameAR: scope.row.monitor.FullName_AR})}} <br /><small>{{scope.row.Timestamp}}</small>
              </template>
        </el-table-column>
        <el-table-column
          :label="$t('BUS')"
          prop="bus.Label"
        >
        </el-table-column>        
        <el-table-column
          :label="$t('STUDENTS')"
          width="180"
          align="center">
          <template slot-scope="scope">
            {{scope.row.student_id.length}}
              </template>
        </el-table-column>

        <el-table-column
          :label="$t('STATUS')"
          align="center"
        >
          <template slot-scope="scope" >
            <el-tag v-bind:type="status[scope.row.statusColor]">
              {{reportStatus[scope.row.statusColor]}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          class-name="firstUpper"
          :label="$t('TYPE')"
        >
        <template slot-scope="scope">
          {{$t(scope.row.incident_type)}}
        </template>
        </el-table-column>
        <el-table-column  align="right">
          <template slot-scope="scope">
            <el-tooltip :content="$t('VIEWINCIDENTDETAILS')" placement="top">
              <el-button  type="small" @click="showIncident(scope.row)"><i class="fa fa-info-circle"></i> {{$t('DETAILS')}}</el-button>
            </el-tooltip>             
          </template>
        </el-table-column>
        <el-table-column align="right">
          <template slot-scope="scope">
            <el-tooltip v-if="isAllowed('flag', 'report/incident')" :content="scope.row.IsSticky ? $t('UNSTICK') : $t('STICK')" placement="top">
              <el-button type="text" @click="flagItem(scope.row)"><i class="fa" :class="[scope.row.IsSticky ? 'fa-flag text-danger' : 'fa-flag-o']" ></i></el-button>
            </el-tooltip>            
          </template>
        </el-table-column>
      </el-table>

      <div style="padding:10px" ref="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 30, 50, 70, 100]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next"
          :total="totalIncidents"
          >
        </el-pagination>
      </div>
      <el-incident-dialog :incident="incident" :visible.sync="incidentBox"></el-incident-dialog>

    </el-card>

  </div>
</template>
<script>
  import Vue from 'vue'
  
  import qs from 'qs'
  import _ from 'lodash'
  import { EventBus } from '../../event-bus.js'
  import IncidentDialog from '@/components/dialogs/Incident'
  export default {
    components: {'el-incident-dialog': IncidentDialog},
    data () {
      return {
        incidents: [],
        incident: {incident_type: null, bus: {Label: null}, monitor: {}},
        students: {},
        loading: true,
        status: {0: 'success', 1: 'warning', 2: 'danger'},
        filter: null,
        active_filter: 'monitor',
        BusMonitorID: '',
        BusID: '',
        TypeIncidentID: '',
        Status: '',
        incidentBox: false,
        monitors: [],
        buses: [],
        totalIncidents: 0,
        currentPage: 1,
        visitedPage: [1],
        new_page: false,
        limit: 20,
        tableHeight: 0
      }
    },
    mounted () {
      this.switchLanguage()
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53)
      this.getIncidents()
      this.getMonitors()
      this.incidentNotification()
    },
    computed: {
      options () {
        let options = [{
          value: 'monitor',
          label: this.$t('SUPERVISOR')
        }, {
          value: 'bus',
          label: this.$t('BUS')
        }, {
          value: 'type',
          label: this.$t('INCIDENTTYPE')
        }, {
          value: 'status',
          label: this.$t('STATUS')
        }]
        return options
      },
      incidentTypes () {
        let incidentTypes = {1: this.$t('CHILDBEHAVIOUR'), 2: this.$t('MEDICAL'), 3: this.$t('DRIVERISSUE'), 4: this.$t('BUSPROBLEM'), 5: this.$t('ACCIDENT'), 6: this.$t('TRAFFIC'), 7: this.$t('CALLPOLICE'), 8: this.$t('CALLSCHOOL'), 9: this.$t('OTHER')}
        return incidentTypes
      },
      reportStatus () {
        let reportStatus = {0: this.$t('RESOLVED'), 1: this.$t('REPORTED'), 2: this.$t('OPEN')}
        return reportStatus
      }
    },
    methods: {
      handleSizeChange (val) {
        this.limit = val
        this.incidents = {}
        this.currentPage = 1
        this.visitedPage = [1]
        this.loading = true
        this.getIncidents()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getIncidents()
      },
      getIncidents (filter = false) {
        let self = this
        if (filter) {
          self.currentPage = 1
          self.visitedPage = [1]
          self.new_page = true
          self.incidents = {}
        }
        if (self.incidents[self.currentPage - 1] !== undefined) return
        this.$http.get('/incident?' + qs.stringify(self.bindCurrentFilters()) + '&limit=' + self.limit + '&offset=' + self.limit * (self.currentPage - 1)).then(function (response) {
          Vue.set(self.incidents, self.currentPage - 1, response.data.incidents)
          self.totalIncidents = response.data.total
          self.new_page = self.loading = false
        }).catch(function (response) {})
      },
      bindCurrentFilters () {
        let data = {filters: []}
        switch (this.active_filter) {
          case 'monitor': data.filters['BusMonitorID'] = this.BusMonitorID
            break
          case 'bus': data.filters['BusID'] = this.BusID
            break
          case 'type': data.filters['TypeIncidentID'] = this.TypeIncidentID
            break
          case 'status': data.filters['Status'] = this.Status
            break
        }
        return data
      },
      showIncident (incident) {
        this.incident = incident
        this.incidentBox = true
      },
      changeFilter () {
        this.BusMonitorID = this.BusID = this.Status = ''
        switch (this.active_filter) {
          case 'monitor': this.getMonitors()
            break
          case 'bus': this.getBuses()
            break
        }
      },
      removeFilter (filter) {
        this.changeFilter()
        this.filter = ''
        this.incidents = {}
        this.getIncidents()
      },
      getMonitors () {
        let self = this
        if (!_.isEmpty(self.monitors)) return
        this.$http.get('/supervisor?ref=incident')
          .then(function (response) {
            self.monitors = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getBuses () {
        let self = this
        if (!_.isEmpty(self.buses)) return
        this.$http.get('/bus')
          .then(function (response) {
            self.buses = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
        if (val === 'bus') this.getBuses()
      },
      flagItem (item) {
        item.IsSticky = !item.IsSticky
        let postData = {id: item.incident_id, type: 'sticky', flag: item.IsSticky ? 1 : 0, name: 'incident'}
        this.$http.post('/report/flag', postData).then(function (response) {
        }).catch(function (response) {})
      },
      incidentNotification () {
        EventBus.$on('incident', incident => {
          this.incidents[0].unshift(incident)
          this.totalIncidents += 1
          if (this.$route.name === 'Incidents') {
            EventBus.incidents.total--
            this.$http.put('/incident/timestamp', {})
          }
        })
      }
    }
  }
</script>

<style>
  #incident .googleMap{margin:-15px; margin-bottom:20px}
  #incident .googleMap input{border-radius: 0; border-left:0; border-right:0}
  #incident .firstUpper{text-transform:capitalize}
</style>




// WEBPACK FOOTER //
// Incident.vue?66c19d0e